<template>
  <div>
    <Observer
      :options="{ rootMargin: '0px 0px -200px 0px', threshold: 1 }"
      @intersect="itisvisible"
    />
    <div
      class="offerCard home-offer"
      @click="dataItemTnc && triggerOfferDetailsModal()"
    >
      <div :style="getOfferComponentTopStyle">
        <div>
          <div class="offerCardTop">
            <div class="">
              <div class="d-flex">
                <p
                  class="couponSavingMessage"
                  :class="[
                    dataIsApplicable ? 'color-white' : 'color-slaty-dark',
                  ]"
                >
                  {{ dataDisplayMessage }}
                </p>
              </div>
            </div>
            <div class="d-flex pl12">
              <span
                v-if="dataPromoCode"
                :class="dataIsApplicable ? 'couponCode' : 'disableCouponCode'"
                >{{ dataPromoCode }}</span
              >
              <!-- <div v-if="showTooltip" class="coupon-tooltip-card">Copied!</div> -->
            </div>
          </div>
        </div>
      </div>
      <div :style="getOfferComponentBottomStyle">
        <div class="offerCardBottom">
          <div class="flex-row">
            <img
              :src="dataOfferIcon"
              alt="dataoffericon"
              v-if="dataExpiryTimer?.endTime || dataBottomMsg"
            />
            <div class="pl5 color-slaty" v-if="dataExpiryTimer?.endTime">
              <div>Coupon expires in</div>
              <div class="bold">{{ expiryTime }}</div>
            </div>
            <div
              class="pl5 color-slaty d-flex align-items-center tl"
              v-else-if="dataBottomMsg"
            >
              {{ dataBottomMsg }}
            </div>
          </div>
          <button
            v-if="dataIsApplicable"
            :class="[
              isOfferApplied
                ? 'remove-cta underline-dotted p5'
                : 'enabledbutton bold ml10 btn',
            ]"
            @click="triggerofferSelected"
          >
            {{ dataAction }}
          </button>
          <button
            v-else-if="!dataIsApplicable"
            class="enabledbutton bold ml10 btn p2"
            @click="goToMenu"
          >
            Add Item
          </button>
        </div>
        <!-- <div class="d-flex justify-content-between align-items-center" v-else>
          <span
            class="offercardtext"
            :class="[dataIsApplicable ? '' : 'color-slaty-dark']"
            >{{ dataText }}</span
          >
          <i
            class="hkfi-arrow-line rotate90 showMoreDetailsSelected"
            @click="triggerOfferDetailsModal()"
          ></i>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  EVENT_IMPRESSION_OFFERS,
  EVENT_CLICK_VIEWMORE_OFFER_CARD,
  EVENT_CLICK_OFFER_SELECT,
  EVENT_CLICK_ADD_MORE_ITEMS,
  EVENT_OFFER_HOME,
} from "../helpers/analyticsEvents";
import Observer from "./Observer.vue";
import Utility from "../helpers/utility";

export default {
  name: "OfferCard",
  props: [
    "dataTitle",
    "dataPromoCode",
    "dataIndex",
    "dataDisplayMessage",
    "dataAction",
    "dataText",
    "dataDiscount",
    "dataItemTnc",
    "dataOfferBackgroundTop",
    "dataOfferBackgroundBottom",
    "dataExpiryTimer",
    "dataIsApplicable",
    "dataBottomMsg",
    "dataOfferIcon",
    "dataTheme",
    "dataFromHome",
  ],
  components: {
    Observer,
  },
  data() {
    return {
      staticImgBaseUrl,
      expiryTime: "",
    };
  },
  mounted() {
    // EVENT_IMPRESSION_OFFERS({
    //   sectionName: this.dataTitle,
    //   sectionPosition: this.dataIndex + 1,
    //   positionWithinSection: "",
    // });
    // console.log('offer-card', this.dataIndex);
    if (this.dataExpiryTimer?.endTime - Date.now() > 0) {
      this.startInterval();
    }
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    expiryTimer() {
      if (this.dataExpiryTimer?.endTime - Date.now() > 0) {
        this.expiryTime = Utility.formatTimestampOffer(
          this.dataExpiryTimer?.endTime - Date.now(),
        );
      }
    },
    startInterval() {
      this.intervalId = setInterval(() => {
        this.expiryTimer();
      }, 1000);
    },
    clearInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    triggerOfferDetailsModal() {
      EVENT_CLICK_VIEWMORE_OFFER_CARD({
        couponCode: this.dataPromoCode,
        sectionPosition: 1,
        positionWithinSection: this.dataIndex + 1,
        sectionName: this.dataTitle,
      });
      if (this.dataFromHome) {
        EVENT_OFFER_HOME({
          userAction: "banner click",
          positionWithinSection: this.dataIndex + 1,
          coupon: this.dataPromoCode,
        });
      }

      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
        this.dataIndex,
      );

      this.dataPromoCode &&
        this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
          campaignId: this.dataItemTnc,
        });
    },
    goToMenu() {
      EVENT_CLICK_ADD_MORE_ITEMS();
      Utility.sendToMenuScreen();
    },
    triggerOfferAppliedModal(event) {
      event?.stopPropagation();
      if (this.$store.state.Offers.appliedOfferPromo != this.dataPromoCode) {
        this.$store.commit(
          keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
          this.dataPromoCode,
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
          this.dataIndex,
        );

        EVENT_CLICK_OFFER_SELECT({
          subCategory: "selected",
          sectionPosition: 1,
          positionWithinSection: this.dataIndex + 1,
          category: this.dataPromoCode,
        });
        this.closeOfferDetailsModal();
        LocalStorageFunc.updateCouponCode(this.dataPromoCode);
        this.$store.commit(keyMapsMutation.UPDATE_MANUAL_OFFER, "");
        document.body.classList.add("body-stop-scroll-mobile");
        this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, true);
        setTimeout(this.closeAppliedModal, 3000);

        if (this.offerFailedMsg) {
          this.showOfferNotApplied = true;
          setTimeout(() => {
            this.showOfferNotApplied = false;
          }, 4000);
        }
      }
    },
    closeOfferDetailsModal(source) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false,
      );
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
    },
    itisvisible() {
      EVENT_IMPRESSION_OFFERS({
        sectionName: this.dataTitle,
        sectionPosition: this.dataIndex + 1,
        positionWithinSection: "",
      });
    },
    triggerofferSelected(e) {
      e.stopPropagation();
      if (this.$store.state.Offers.appliedOfferPromo != this.dataPromoCode) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_OFFER_THEME,
          this.dataTheme,
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
          this.dataPromoCode,
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
          false,
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
          this.dataIndex,
        );
        EVENT_CLICK_OFFER_SELECT({
          subCategory: "selected",
          sectionPosition: this.dataSectionPosition,
          positionWithinSection: this.dataIndex + 1,
          category: this.dataPromoCode,
        });
        if (this.dataFromHome) {
          EVENT_OFFER_HOME({
            userAction: "apply",
            positionWithinSection: this.dataIndex + 1,
            coupon: this.dataPromoCode,
            subcategory: "application success",
          });
        }
        LocalStorageFunc.updateCouponCode(this.dataPromoCode);
        this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
        this.$store.commit(keyMapsMutation.UPDATE_VIEW_ALL_OFFERS, false);
        if (Utility.isCurrentlyAtUrl("/cart-unified")) {
          this.$store.dispatch(keyMapsAction.CREATE_CART_ITEMS_API, {
            code: this.dataPromoCode,
            couponDetail: this.dataDisplayMessage,
          });
        }
        if (
          Utility.isCurrentlyAtUrl("/store") ||
          Utility.isCurrentlyAtUrl("/cart-unified")
        ) {
          this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, true);
          setTimeout(this.closeAppliedModal, 3000);
        } else {
          LocalStorageFunc.setOfferAppliedModal(true);
          Utility.redirectToHomeOrRedirectUrl();
        }
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER_THEME, "");

        EVENT_CLICK_OFFER_SELECT({
          subCategory: "unselected",
          sectionPosition: this.dataSectionPosition,
          positionWithinSection: this.dataIndex + 1,
          category: this.dataPromoCode,
        });
        if (this.dataFromHome) {
          EVENT_OFFER_HOME({
            userAction: "remove",
            positionWithinSection: this.dataIndex + 1,
            coupon: this.dataPromoCode,
            subcategory: "application success",
          });
        }
        this.$store.commit(keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO, "");
        LocalStorageFunc.updateCouponCode("");
        this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
      }
    },
  },
  computed: {
    isDesktop() {
      return Utility.isDesktop();
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    appliedOfferPromo() {
      return this.$store.state.Offers.appliedOfferPromo;
    },
    getOfferComponentTopStyle() {
      return {
        background: `url(${this.dataOfferBackgroundTop})`,
        backgroundRepeat: `no-repeat`,
        backgroundSize: `100% auto`,
        padding: "12px 13px",
      };
    },
    getOfferComponentBottomStyle() {
      return {
        background: `url(${this.dataOfferBackgroundBottom})`,
        backgroundRepeat: `no-repeat`,
        backgroundSize: `100% auto`,
        padding: "10px",
        flex: "1",
      };
    },
    isOfferApplied() {
      return this.$store.state.Offers.appliedOfferPromo === this.dataPromoCode;
    },
  },
};
</script>
